// facebook video directive
//
//   <facebook-video settings="broadcast.simulcast_configurations[0]" />
//

let module = angular.module('app.directives');

module.directive('facebookVideo', (Facebook) => {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      settings: '=',
    },
    template: `
      <div ng-show="readyToShow" class="facebook-embed"></div>
    `,
    link: (scope, element) => {
      scope.$watch(
        () => scope.settings && scope.settings.fb_id,
        (id) => {
          if (!id) return;
          scope.readyToShow = true;
          element.find('.facebook-embed').html(`
          <div class="fb-video"
               data-href="https://www.facebook.com/video.php?v=${id}"
               data-allowfullscreen="true"
               data-width="500"></div>
        `);
          setTimeout(() => window['FB'] && FB.XFBML.parse(), 0);
        }
      );
    },
  };
});



// WEBPACK FOOTER //
// ./app/directives/facebook-video.js